import { type MetaFunction } from '@remix-run/node'

export const shouldRevalidate = () => false
export const handle = { showMap: true }
export const meta: MetaFunction = () => [{ title: 'Map Search - Associate' }]

export default function AppMapIndexRoute() {
  return null
}
